import {
    transform, isArray, isObject, camelCase, snakeCase, isNull, isUndefined,
} from 'lodash';

export const toCamelCase = <T extends any>(obj : any) : T => {
    if (!obj) return obj;

    // Automatické rozbalení Laravel Resource "data" wrapperu, pokud neobsahuje meta informace
    if (isObject(obj) && !isArray(obj) && 'data' in obj && Object.keys(obj).length === 1) {
        return toCamelCase(obj.data);
    }

    return transform(obj, (acc : any, value : any, key : any, target : any) : void => {
        const camelKey = isArray(target)
            ? key
            : camelCase(key);

        // Vynecháme hloubkovou konverzi pro marže a služby, které mají specifické snake_case klíče
        acc[camelKey] = (isObject(value) && !['margins', 'services'].includes(camelKey))
            ? toCamelCase(value)
            : value;
    });
};

export const toSnakeCase = <T extends any>(obj : object) : T => {
    return transform(obj, (acc : any, value : any, key : any, target : any) : void => {
        const snakeKey = isArray(target)
            ? key
            : snakeCase(key);

        acc[snakeKey] = isObject(value)
            ? toSnakeCase(value)
            : value;
    });
};

export const buildQuery = (input : Record<string, unknown>) : string => {
    const query = new URLSearchParams();

    Object.entries(input).forEach(([key, value]) => {
        if (!isNull(value) && !isUndefined(value)) {
            query.append(snakeCase(key), String(value));
        }
    });
    const search = query.toString();

    return search
        ? '?' + search
        : '';
};
